export default "__VITE_ASSET__4862f473__"